import React from "react";
import Footer from "./compoents/Footer";
import AboutUS from "./compoents/Layout/AboutUS";
import Cards from "./compoents/Layout/Cards";
import Contact from "./compoents/Layout/Contact";
import Images from "./compoents/Layout/Images";
import InfoCards from "./compoents/Layout/InfoCards";
import "./App.css";
import ScrollNav from "./compoents/Layout/ScrollNav";


function App() {
  return (
    <div>
    <ScrollNav/>
    <Footer />
    </div>
  );
}

export default App;
